export class AWSSendMail {
    TEMPLATE_ID:number;
    TEMPLATE_NAME:string;
    SHEET_ID:string;
    ROWS_COUNT:number;
    START_TIME:string;
    IS_SCHEDULED:boolean;
}

